package org.solyton.solawi.bid.application.`data`.ui

import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.application.ui.page.user.`data`.UiStateOfOrganizationPage

/**
 * Autogenerated Lens.
 * Read and manipulate [UiStates.ofOrganizationPage]
 */
@ReadWrite
public val ofOrganizationPage: Lens<UiStates, UiStateOfOrganizationPage> by lazy {
      Lens(
        get = { whole -> whole.ofOrganizationPage },
        set = { part -> { whole -> whole.copy(ofOrganizationPage = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiStates.ofOrganizationPage]
 */
@ReadWrite
public
    fun UiStates.ofOrganizationPage(`set`: UiStateOfOrganizationPage.() -> UiStateOfOrganizationPage):
    UiStates = copy(ofOrganizationPage = set(ofOrganizationPage))
